import getDefaultBonusPeriod from './getDefaultBonusPeriod';
import getBonusPeriodContainingToday from './getBonusPeriodContainingToday';

/**
 * The default period to show for a sub-period programme, by screen. Approvals
 * signs off a completed period, so it uses the status-priority default (the
 * period awaiting sign-off). Every other (content) screen opens on the period
 * containing today so the board lands on the current week, falling back to the
 * status-priority default when today sits outside every period.
 *
 * Sub-period setups are URL-param-free (see BonusAppProvider), so this is
 * re-applied on each screen change rather than persisted via the URL.
 */
const resolveDefaultBonusPeriod = ({
  bonusPeriods,
  isApprovalsScreen,
}: {
  bonusPeriods: BonusTypes.BonusPeriod[];
  isApprovalsScreen: boolean;
}): BonusTypes.BonusPeriod | undefined =>
  isApprovalsScreen
    ? getDefaultBonusPeriod(bonusPeriods)
    : getBonusPeriodContainingToday(bonusPeriods) ??
      getDefaultBonusPeriod(bonusPeriods);

export default resolveDefaultBonusPeriod;
